import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'

export default function DashletTooltip({ columnName, tooltipText, position = 'right' }) {
  return (
    <>
      {columnName}
      <span
        className={`has-tooltip-arrow has-tooltip-multiline has-tooltip-${position} has-tooltip-primary lox-no-border`}
        data-tooltip={tooltipText}
      >
        <FontAwesomeIcon
          icon={faQuestionCircle}
          className="has-text-link ml-1"
        />
      </span>
    </>
  )
}
